export const dialogActions = {
   COMMON_ACTIONS: {
      CONFIRMATION_DIALOG: "confirmationDialog",
      CLOSE_DIALOG: "closeDialog",
      CONFIRM_DIALOG: "confirmDialog",
   },
};
